import { Header } from './header';
import { HeaderCluster } from './header-cluster';
import { HeaderItem } from './header-item';

export class UserHeader implements Header {
  public name = '';
  public clusters: HeaderCluster[] = [];

  constructor(name: string, priceManager = false, pimAccess = false, operationalAccess = false) {
    this.name = name;

    const portfolioItems: HeaderItem[] = [
      {
        name: 'Parceiros',
        url: 'external/partners',
      },
      {
        name: 'Portfólio',
        url: 'portfolio',
      },
    ];
    if (pimAccess) {
      portfolioItems.push({
        name: 'PIM',
        url: 'pim',
      });
    }
    if (priceManager) {
      portfolioItems.push({
        name: 'Preços',
        url: 'portfolio/precos',
      });
    }

    // Granted, not inferred: an operational account is no longer required to hold the dev ANF,
    // so this list is the same one DevHeader builds.
    const reportingItems: HeaderItem[] = [
      { name: 'Relatórios', url: 'reporting' },
      { name: 'Oportunidades', url: 'opportunities' },
      { name: 'Easy Gest', url: 'external/easygest' },
    ];
    if (operationalAccess) {
      reportingItems.push({ name: 'Portal Operacional', url: 'operational' });
    }

    this.clusters = [
      {
        items: [
          {
            name: 'Home',
            url: '',
          },
          {
            name: 'Contactos',
            url: 'external/contacts',
          },
          {
            name: 'Destaques',
            url: 'campaigns',
          },
        ],
      },
      {
        items: portfolioItems,
      },
      {
        items: [
          {
            name: 'Encomendas',
            url: 'orders',
          },
          {
          name: 'Campanhas',
          url: 'campanhas',
          },
          {
          name: 'Foco',
          url: 'foco',
          }
          // {
          //   name: 'Lançamentos',
          //   url: '',
          // },
        ],
      },
      {
        items: [
          // {
          //   name: 'Training Circle',
          //   url: 'external/training',
          // },
          // {
          //   name: '20 Minute Pitch',
          //   url: 'external/pitch',
          // },
          // {
          //   name: 'Tutoriais',
          //   url: 'external/tutorials',
          // },
          {
            name: 'Formação',
            url: 'external/training',
          },
        ],
      },
      {
        items: [
          {
            name: 'Montras Digitais',
            url: 'external/digital-display',
          },
          {
            name: 'Redes Sociais',
            url: 'external/social-networks',
          },
          {
            name: 'Expositores',
            url: 'external/exhibitors',
          },
/*            {
            name: 'BClient',
            url: 'external/bclient',
          },  */
        ],
      },
      {
        items: reportingItems,
      },
    ];
  }
}
